module.exports = __webpack_public_path__ + "img/tree5.ce32031d.png";